@if (!loading) {
  <app-patient-header [patient]="patient" />
  <div class="page-container">
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">Patient Referrals From EHR Feeds</h5>
          @if (!loadingReferrals) {
            @if (referrals.length > 0 || ineligibleReferrals.length > 0) {
              <app-referrals-standard-listing
                [dark]="true"
                [eligibleReferrals]="referrals"
                [ineligibleReferrals]="ineligibleReferrals"
                [showIneligibleReferrals]="showIneligibleReferrals"
                [compactClientView]="false" />
            } @else {
              No referrals of this type found.
            }
          } @else {
            <mat-spinner diameter="30" />
          }
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">Referral Evidence Found in EHR</h5>
          @if (!loadingEhrReferralVerifications) {
            @if (ehrReferralVerifications.length > 0) {
              <app-referrals-ehr-listing
                [dark]="true"
                [ehrReferralVerifications]="ehrReferralVerifications"
                [compactClientView]="false" />
            } @else {
              No referrals of this type found.
            }
          } @else {
            <mat-spinner diameter="30" />
          }
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">Patient Referrals From Client Tasks</h5>
          @if (!loadingClientReferralVerifications) {
            @if (clientReferralVerifications.length > 0) {
              <app-referrals-client-listing
                [dark]="true"
                [clientReferralVerifications]="clientReferralVerifications"
                [compactClientView]="false" />
            } @else {
              No referrals of this type found.
            }
          } @else {
            <mat-spinner diameter="30" />
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <mat-spinner />
}
